import { createAsyncAction } from "typesafe-actions";
import type { FetchError } from "app/pages/sales-intelligence/types";
import type { CrmList } from "../../types";

export const fetchCrmListsAsync = createAsyncAction(
    "@@si/management/FETCH_CRM_LISTS_START",
    "@@si/management/FETCH_CRM_LISTS_SUCCESS",
    "@@si/management/FETCH_CRM_LISTS_FAILURE",
)<void, CrmList[], FetchError>();
